var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1664V18.333V14.1664Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1664V18.333",
    stroke: "#626262",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50045 8.96638C7.50028 9.27645 7.41362 9.58033 7.25022 9.84384C7.08681 10.1074 6.85312 10.3201 6.57545 10.458L5.09211 11.208C4.81444 11.346 4.58076 11.5587 4.41735 11.8223C4.25394 12.0858 4.16728 12.3896 4.16711 12.6997V13.333C4.16711 13.5541 4.25491 13.766 4.41119 13.9223C4.56747 14.0786 4.77943 14.1664 5.00045 14.1664H15.0004C15.2215 14.1664 15.4334 14.0786 15.5897 13.9223C15.746 13.766 15.8338 13.5541 15.8338 13.333V12.6997C15.8336 12.3896 15.747 12.0858 15.5835 11.8223C15.4201 11.5587 15.1865 11.346 14.9088 11.208L13.4254 10.458C13.1478 10.3201 12.9141 10.1074 12.7507 9.84384C12.5873 9.58033 12.5006 9.27645 12.5004 8.96638V5.83305C12.5004 5.61203 12.5882 5.40007 12.7445 5.24379C12.9008 5.08751 13.1128 4.99972 13.3338 4.99972C13.7758 4.99972 14.1997 4.82412 14.5123 4.51156C14.8249 4.199 15.0004 3.77508 15.0004 3.33305C15.0004 2.89102 14.8249 2.4671 14.5123 2.15454C14.1997 1.84198 13.7758 1.66638 13.3338 1.66638H6.66711C6.22509 1.66638 5.80116 1.84198 5.4886 2.15454C5.17604 2.4671 5.00045 2.89102 5.00045 3.33305C5.00045 3.77508 5.17604 4.199 5.4886 4.51156C5.80116 4.82412 6.22509 4.99972 6.66711 4.99972C6.88813 4.99972 7.10009 5.08751 7.25637 5.24379C7.41265 5.40007 7.50045 5.61203 7.50045 5.83305V8.96638Z",
    stroke: "#626262",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.82715,
    width: 0.970022,
    height: 19.7341,
    rx: 0.485011,
    transform: "rotate(-58.5263 2 5.82715)",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinIcon);
export default __webpack_public_path__ + "static/media/unpin-icon.6b013ecbf21237d4488825662131d031.svg";
export { ForwardRef as ReactComponent };